import { render, staticRenderFns } from "./ymdCardV2.vue?vue&type=template&id=a3ded246&scoped=true&"
import script from "./ymdCardV2.vue?vue&type=script&lang=js&"
export * from "./ymdCardV2.vue?vue&type=script&lang=js&"
import style0 from "./ymdCardV2.vue?vue&type=style&index=0&id=a3ded246&prod&lang=css&"
import style1 from "./ymdCardV2.vue?vue&type=style&index=1&id=a3ded246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ded246",
  null
  
)

export default component.exports